import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { animationValues, transitionValues } from "../utils/pageTransitions";
import logo from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import {
  adminLogin,
  forgot_password,
  verify_token,
} from "../redux/actions/adminActions";
import { connect } from "react-redux";
import Spinner from "../components/reusables/spinner";
import InputField from "../components/reusables/input";
import "../styles/auth.css";
import PinInput from "../components/reusables/pinInput";

function VerifyToken({ verify_token, reset_email }) {
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setData] = useState({ email: "" });

  const handleChange = (e) => {
    setData({
      ...formData,
      email: e.target.value,
    });
  };

  const handleLoading = () => {
    setIsLoading(true);
  };

  const done = () => {
    setIsLoading(false);
  };

  const submit = (e) => {
    e.preventDefault();
    handleLoading();
    let formData = { token: code, email: reset_email };
    verify_token(formData, navigate, () => done());
  };

  const handleInputChange = (e) => {
    setCode(e);
  };

  useEffect(() => {
    if (reset_email == "") {
      // navigate("/login");
    }
  }, [reset_email]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="fullHeight admin">
        <div className="formHolder container center">
          <div className="content vAlign">
            <img src={logo} alt="" className="mAuto pb-5" />
            <div className="authCard alignOnly">
              <div className="w-100">
                <h2 className="sectionHead--small textIsBold pt-3">
                  Reset Password
                </h2>
                <p className="sectionText--small mt-2 px-4">
                  Enter the reset token sent to your email.
                </p>

                <form className="pt-3" onSubmit={submit}>
                  <div>
                    <PinInput onChange={handleInputChange} />
                  </div>

                  <div className=" mobileBlock">
                    <div className="pt-3">
                      {isLoading ? (
                        <button className="btn__filled textIsBold center w-100">
                          Please Wait {""}
                          <Spinner />
                        </button>
                      ) : (
                        <button className="btn__filled textIsBold w-100">
                          Proceed
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  reset_email: state.admin.reset_email,
});

const mapDispatchToProps = (dispatch) => ({
  verify_token: (data, navigator, done) =>
    dispatch(verify_token(data, navigator, done)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyToken);
